import { NodeId, nodesFlux, useEditorSelector } from '@candulabs/craft';
import { useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { ENDPOINTS } from 'site-constants';

import { ComponentCategory, ComponentSchema, EnumSchema, NodeLocation, Schema } from 'craft/types';
// TODO: refactor this when hammock is splitted between core and helper fns
import { createCacheKey } from 'hammock/actionUtils';
import { useCreatePayload } from 'hammock/hooks';

const schemaWithRte = (schema: Schema): Schema => ({
  ...schema,
  components: [
    ...schema.components,
    {
      type: 'RichTextEditor',
      category: ComponentCategory.Typography,
      location: NodeLocation.Internal,
    },
  ],
});

// get the editor directly from hammock. this is a little hack to reuse the hammock selectors to actually fetch the content.
export const selectSchema = (schema: Schema) => schemaWithRte(schema);

export const useSchema = (): Schema => {
  const queryClient = useQueryClient();
  const { get } = useCreatePayload(ENDPOINTS.schemas);
  const result = queryClient.getQueriesData(createCacheKey(get({ id: 'candu' })));
  const schema = (result[0][1] as any) as Schema;

  return selectSchema(schema);
};

export const useEnum = (enumId: string): EnumSchema | undefined => {
  const queryClient = useQueryClient();
  const { get } = useCreatePayload(ENDPOINTS.schemas);
  const result = queryClient.getQueriesData(createCacheKey(get({ id: 'candu' })));
  const schema = (result[0][1] as any) as Schema;
  return schema.enums.find(({ id }) => id === enumId);
};

export const useComponentSchema = (componentType?: string): ComponentSchema | undefined => {
  const queryClient = useQueryClient();
  const { get } = useCreatePayload(ENDPOINTS.schemas);
  const result = queryClient.getQueriesData(createCacheKey(get({ id: 'candu' })));
  const schema = (result[0][1] as any) as Schema;
  return schema.components.find(({ type }) => type === componentType);
};

export const useComponentSchemaById = (id: NodeId): ComponentSchema | undefined => {
  const nameSelector = useMemo(() => nodesFlux.selectors.getNodeName(id), [id]);
  const name = useEditorSelector(nameSelector);
  return useComponentSchema(name);
};
